import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Liability } from '../../models/liability.model';

@Component({
standalone: false,
  selector: 'app-delete-single-automatic-payment-confirmation-dialog',
  styleUrls: ['./delete-single-automatic-payment-confirmation-dialog.component.scss'],
  templateUrl: './delete-single-automatic-payment-confirmation-dialog.component.html',
})
export class DeleteSingleAutomaticPaymentConfirmationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: Liability) {}
}
